export const MIN_MAX_CONFIG_PERMISSIONS = {
  VIEW: 'carc_view_min_max_values',
  MODIFY: 'carc_configure_min_max_values',
  DELETE: 'carc_delete_min_max_values',
} as const;

export type MinMaxConfigPermissions = typeof MIN_MAX_CONFIG_PERMISSIONS[keyof typeof MIN_MAX_CONFIG_PERMISSIONS];
